<template>
  <div class="flex items-center space-x-4">
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium text-gray-900 truncate">
        {{ fullName }}
      </p>
    </div>
    <div class="flex space-x-2">
      <BaseButton primary outline small :disabled="disabled" @click="associate(person)">
        Associate
      </BaseButton>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  methods: {
    associate() {
      this.$emit('associate', this.person);
    },
  },
  computed: {
    fullName() {
      const { firstName, lastName } = this.person;

      return [firstName, lastName].filter(Boolean).join(' ');
    },
  },
};
</script>
